export var AccessConditionEffect;
(function (AccessConditionEffect) {
    AccessConditionEffect["RULE_EFFECT_INCLUSIVE"] = "INCLUSIVE";
    AccessConditionEffect["RULE_EFFECT_EXCLUSIVE"] = "EXCLUSIVE";
})(AccessConditionEffect || (AccessConditionEffect = {}));
